var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 9.16667H14.8333C15.7667 9.16667 16.2335 9.16667 16.59 9.34832C16.9036 9.50811 17.1585 9.76308 17.3183 10.0767C17.5 10.4332 17.5 10.8999 17.5 11.8333V17.5M10.8333 17.5V5.16667C10.8333 4.23325 10.8333 3.76654 10.6517 3.41002C10.4919 3.09641 10.2369 2.84144 9.92331 2.68166C9.56679 2.5 9.10008 2.5 8.16666 2.5H5.16666C4.23324 2.5 3.76653 2.5 3.41001 2.68166C3.0964 2.84144 2.84143 3.09641 2.68165 3.41002C2.49999 3.76654 2.49999 4.23325 2.49999 5.16667V17.5M18.3333 17.5H1.66666M5.41666 5.83333H7.91666M5.41666 9.16667H7.91666M5.41666 12.5H7.91666",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e05f1f1a9354533775092378f89c83e2.svg";
export { ForwardRef as ReactComponent };